import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { FunctionsService } from 'src/app/services/functions/functions.service';

@Component({
  selector: 'app-report-subscriptions-detail',
  templateUrl: './report-subscriptions-detail.page.html',
  styleUrls: ['./report-subscriptions-detail.page.scss'],
})
export class ReportSubscriptionsDetailPage implements OnInit {
  row: any;

  constructor(
    private navParams: NavParams,
    public modalCtrl: ModalController,
    public funcServ: FunctionsService) { }

  ngOnInit() {
    this.row = this.navParams.get('row');
    // console.log(this.row);
  }

}